import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import config from 'config'
import { utils } from 'services'
import { image } from 'services'
import { AppActionCreators } from 'app/reducers/AppRedux'
import MultiSlider from 'components/MultiSlider'
import { Button } from 'controls'
import Container from 'components/Layout/Container'

import { bannerItemStyles, actionsStyles } from './styles'

const NEXICREDITO_PHONE = config('NEXICREDITO_PHONE')

function Actions({ actions }) {
  if (!actions || actions.length === 0) {
    return null
  }

  return (
    <div className="actions-container">
      {actions.map(action => (
        <Button
          color={action.color || 'primary'}
          href={action.url}
          target="_blank"
          size="large"
          key={action.url + action.label}
          className="action-button"
        >
          {action.label}
        </Button>
      ))}

      <style jsx>{actionsStyles}</style>
    </div>
  )
}

function BannerPicture({
  fullSize,
  desktopBackgroundImage,
  tabletBackgroundImage,
  mobileBackgroundImage,
}) {
  const mobileBackgroundImageWebp = utils.getCroppedImage({
    file: mobileBackgroundImage,
    watermark: false,
  })
  const tableBackgroundImageWebp = utils.getCroppedImage({
    file: tabletBackgroundImage,
    watermark: false,
  })
  const desktopBackgroundImageWebp = utils.getCroppedImage({
    file: desktopBackgroundImage,
    watermark: false,
  })
  return (
    <picture
      className={classNames('banner-item-cover', { 'full-size': fullSize })}
    >
      <source srcset={mobileBackgroundImageWebp} media="(max-width: 576px)" />
      <source srcset={tableBackgroundImageWebp} media="(max-width: 992px)" />
      <img src={desktopBackgroundImageWebp} />
      <style jsx>{bannerItemStyles}</style>
    </picture>
  )
}

function WithLink({ href, children }) {
  if (href) {
    return (
      <a href={href} target="_blank">
        {children}
      </a>
    )
  }

  return children
}

function BannerItem({
  desktopBackgroundImage,
  tabletBackgroundImage,
  mobileBackgroundImage,
  mainColor,
  backgroundColor,
  href,

  title,
  titleColor,

  subTitle,
  subTitleColor,

  content,
  contentColor,

  actions,
}) {
  return (
    <WithLink href={href}>
      <div className="banner-item" style={{ backgroundColor }}>
        <BannerPicture
          fullSize
          desktopBackgroundImage={desktopBackgroundImage}
          tabletBackgroundImage={tabletBackgroundImage}
          mobileBackgroundImage={mobileBackgroundImage}
        />

        <div className="banner-item-content">
          <hgroup>
            {title && (
              <h1 style={{ color: titleColor || mainColor }}>{title}</h1>
            )}
            {subTitle && (
              <h2 style={{ color: subTitleColor || mainColor }}>{subTitle}</h2>
            )}
          </hgroup>

          {content && (
            <p className="content" style={{ color: contentColor || mainColor }}>
              {content}
            </p>
          )}

          <Actions actions={actions} />
        </div>

        <style jsx>{bannerItemStyles}</style>
      </div>
    </WithLink>
  )
}

const DEFAULT_SLIDE = {
  mainColor: null,
  desktopBackgroundImage: image('/hero/homepage/home-keys.jpg'),
  tabletBackgroundImage: image('/hero/homepage/home-keys.jpg'),
  mobileBackgroundImage: image('/hero/homepage/home-keys.jpg'),
  backgroundColor: null,
  href: null,
  title: null,
  subTitle: null,
  content: null,
  actions: null,
}

const CONFIG = {
  autoplay: true,
  speed: 1000,

  slides: [DEFAULT_SLIDE],
}

const buildSlideKey = ({
  desktopBackgroundImage,
  tabletBackgroundImage,
  mobileBackgroundImage,
  href,
  title,
}) => {
  return (
    (desktopBackgroundImage || tabletBackgroundImage || mobileBackgroundImage) +
    (href + title)
  )
}

function HomeBannerSlider(props) {
  const dispath = useDispatch()
  const [key, setKey] = useState(() => utils.getGuid())
  const { bannerSlides, feedback } = useSelector(state => state.app.dashboard)
  const menuExpanded = useSelector(state => state.app.menuExpanded)

  useEffect(() => {
    let id = setTimeout(() => {
      setKey(utils.getGuid())
    }, 300)
    return () => clearTimeout(id)
  }, [menuExpanded])

  useEffect(() => {
    dispath(AppActionCreators.dashboardRequest())
  }, [])

  const { speed, autoplay } = { ...props, ...CONFIG }
  const slides = (bannerSlides.length > 0 && bannerSlides) || CONFIG.slides

  return (
    <Container>
      <MultiSlider key={key} dots={true} speed={speed} autoplay={autoplay}>
        {slides.map(slide => (
          <BannerItem key={buildSlideKey(slide)} {...slide} />
        ))}
      </MultiSlider>
    </Container>
  )
}

export default HomeBannerSlider
